"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileTypeIcon = getFileTypeIcon;

var _FileTypeCsv = _interopRequireDefault(require("@insided/shared/icons/FileTypeCsv"));

var _FileTypeDoc = _interopRequireDefault(require("@insided/shared/icons/FileTypeDoc"));

var _FileTypePdf = _interopRequireDefault(require("@insided/shared/icons/FileTypePdf"));

var _FileTypePpt = _interopRequireDefault(require("@insided/shared/icons/FileTypePpt"));

var _FileTypeTxt = _interopRequireDefault(require("@insided/shared/icons/FileTypeTxt"));

var _FileTypeXls = _interopRequireDefault(require("@insided/shared/icons/FileTypeXls"));

var _FileTypeXml = _interopRequireDefault(require("@insided/shared/icons/FileTypeXml"));

var _FileTypeZip = _interopRequireDefault(require("@insided/shared/icons/FileTypeZip"));

var fileTypeIconMap = {
  // Spreadsheets
  csv: _FileTypeCsv.default,
  xls: _FileTypeXls.default,
  xlsx: _FileTypeXls.default,
  // Documents
  doc: _FileTypeDoc.default,
  docx: _FileTypeDoc.default,
  // PDF
  pdf: _FileTypePdf.default,
  // Presentations
  ppt: _FileTypePpt.default,
  pptx: _FileTypePpt.default,
  // Text
  txt: _FileTypeTxt.default,
  // Data/Code
  xml: _FileTypeXml.default,
  // Archives
  zip: _FileTypeZip.default
};

function getFileTypeIcon(extension) {
  var normalizedExt = extension.replace(/^\./, '').toLowerCase();
  return fileTypeIconMap[normalizedExt] || null;
}